import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Rating } from "react-simple-star-rating";
import { MdPersonOutline } from "react-icons/md";
import { Link } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";
import cross from "../../assets/letter-x.png";
import { FaTrashAlt, FaEdit } from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
import {
  cleanCarDelete,
  deleteCar,
  getmycars,
} from "../../redux/Slice/carSlice";
import {
  cleanData,
  increaseStep,
  setCarImagesResponse,
  setEditCarID,
  storeCarDetails,
  storeCarInsurance,
  storeDriverDetails,
  storeLoaction,
  storePersonalDetails,
} from "../../redux/Slice/formSlice";
import dayjs from "dayjs";
import { toast } from "react-toastify";

const MyVehicleCard = ({
  carData,
  carId,
  carImage,
  carName,
  carSeat,
  carPrice,
  rating,
}) => {
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const getMyCarsData = useSelector((state) => state?.car?.getMyCarsData);
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const carDeleteHandle = (carId) => {
    if (carId) {
      dispatch(deleteCar({ carId }));
    }
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  function carEditHandle(id, carData) {
    dispatch(cleanData());
    const carFeatureIds =
      carData?.features?.filter((ele) => ele?._id).map((ele) => ele._id) || [];

    // dispatch(increaseStep())
    dispatch(setEditCarID(carData?._id));
    dispatch(
      storeLoaction({
        lat: carData?.location?.coordinates[1],
        lng: carData?.location?.coordinates[0],
      })
    );
    // dispatch(storeDriverDetails(getMyCarsData?.driver))
    // dispatch(storeCarInsurance())
    let fullNumber=userDetail?.data?.country_code+userDetail?.data.phoneNumber;
    // dispatch(
    //   storePersonalDetails({
    //     fullName: userDetail?.data?.name,
    //     email: userDetail?.data?.emailId,
    //     phone: userDetail?.data?.UserPhoneNumber,
    //     // phone: fullNumber,
    //     userPhone: userDetail?.data?.phoneNumber,
    //     countryCode: userDetail?.data?.country_code,
    //     address: userDetail?.data?.address,
    //     identityFront: userDetail?.data?.identityFront,
    //     identityBack: userDetail?.data?.identityBack,
    //   })
    // );
    // dispatch(
    //   storeDriverDetails({
    //     fullName: carData?.driver?.name,
    //     age: carData?.driver?.age,
    //     phone: carData?.driver?.phoneNumber,
    //     driverPhoneNumber:carData?.driver?.phoneNumber,
    //     driverCountryCode:carData?.driver?.driver_country_code,
    //     email: carData?.driver?.email,
    //     driverRent: carData?.driver?.rent,
    //     IDfront: carData?.driver?.identityCardFrontSide,
    //     IDback: carData?.driver?.identityCardBackSide,
    //     licenceImg: carData?.driver?.licenceCard,
    //     licenceIssueDate: carData?.driver?.licenceIssueDate
    //       ? dayjs(carData?.driver?.licenceIssueDate).format("MM-DD-YYYY")
    //       : "",
    //     licenceExpiryDate: carData?.driver?.licenceExpiryDate
    //       ? dayjs(carData?.driver?.licenceExpiryDate).format("MM-DD-YYYY")
    //       : "",
    //     withDriver: carData?.withDriver,
    //   })
    // );

    dispatch(
      storeCarInsurance({
        pricePerDay: carData?.pricePerDay,
        companyName: carData?.insurance?.companyName,
        policyNumber: carData?.insurance?.policyNumber,
        diskImage: carData?.insurance?.disk_image,
        expiryDate: carData?.insurance?.expiryDate
          ? dayjs(carData?.insurance?.expiryDate).format("MM-DD-YYYY")
          : "",
        insuranceAvailable: carData?.insuranceAvailable,
        
      })
    );

    dispatch(
      storeCarDetails({
        carMake: carData?.maker?._id,
        carModel: carData?.model?._id,
        carType: carData?.carCategoryId?._id,
        manufactureYr: carData?.yearOfManufacture,
        registrationNum: carData?.registrationNumber,
        seat: carData?.numberOfSeats,
        mileage: carData?.mileage,
        fuelType: carData?.fuelType,
        motor: carData?.motor,
        speed: carData?.topSpeed,
        power: carData?.power,
        carFeature: carFeatureIds,
        carLocation: carData?.carLocation,
        carFrontImg: carData?.frontImage,
        carSeatsImg: carData?.seat_image,
        carInteriorImg: carData?.interior_image,
        carChassisImg: carData?.chasis_image,
        carDashboardImg: carData?.dashboard_image,
        carBackImg: carData?.backImage,
        carLeftImg: carData?.leftImage,
        carRightImg: carData?.rightImage,
        numberPlateImg: carData?.numberPlateImage,
        gpsAvaiblity: carData?.gpsAvaiblity,
        gpsPayment: carData?.gpsPayment,
        driverToggle: carData?.withDriver,
      })
    );
    
    dispatch(setCarImagesResponse({
      carFrontImg: carData?.frontImage,
      carBackImg: carData?.backImage,
      carLeftImg:  carData?.leftImage,
      carRightImg: carData?.rightImage,
      carInteriorImg: carData?.interior_image,
      carSeatsImg:carData?.seat_image ,
      carDashboardImg:  carData?.dashboard_image,
      carChassisImg: carData?.chasis_image,
      numberPlateImg:carData?.numberPlateImage,
      IDfront:  carData?.driver?.identityCardFrontSide,
      IDback:carData?.driver?.identityCardBackSide,
      licenceImg: carData?.driver?.licenceCard,
      diskImage: carData?.insurance?.disk_image ,
    }))
    // dispatch(storePersonalDetails(userDetail?.data))
    navigate("/rentyourcar");
    //
    //
    //
    //
    //
    // increaseStep
  }

  return (
    <div className="card card-shadow border-0 h-100 position-relative">
      <div className="dropdown bg-transparent d-flex justify-content-center three_dots p-0">
        <button
          type="button"
          className="btn px-2 dropdown-action bg-drop px-0 border-0"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <BsThreeDotsVertical />
        </button>
        <ul className="dropdown-menu dropdown-menu-width dropdown-menu-end py-2">
          <li className="text-center mb-2 cursor-pointer">
            <FaEdit
              className="edit-icon-fav fs-5 text-dark pointor"
              onClick={() => carEditHandle(carId, carData)}
            />
          </li>
          <li className="text-center mb-2 cursor-pointer pointor">
            <FaTrashAlt
              className="trash-icon-fav fs-5"
              onClick={() => carDeleteHandle(carId)}
            />
          </li>
        </ul>
      </div>
      <div className="row">
        <div className="col-12">
          <img
            src={`${baseURL}${carImage}`}
            className="fav-img rounded-top"
            alt="car-image"
          />
        </div>
        <div className="col-12">
          <div className="card-body">
            {/* <div className=" px-4 pt-2"> */}
            <div className="d-flex flex-column justify-content-evenly align-items-start">
              {/* <div className=""> */}
              {/* <h3 className="card-title text-capitalize font">{carName}</h3> */}
              <div className="d-flex flex-row justify-content-between align-items-center  w-100">
                <h5 className="card-title font secondaryColor text-capitalize">
                  {carName}
                </h5>
                <div>
                  <p className="car-price m-0 fs-5 font">K{carPrice}/Day</p>
                </div>
              </div>
              <Rating
                iconsCount={5}
                fillColor="#f1a545"
                readonly={true}
                initialValue={rating}
                size="16px"
              />
              <p className="secondaryColor seater">
                <MdPersonOutline className="seater-icon clr-theme fs-6 icon-user-m" />{" "}
                <span>{carSeat} seater</span>{" "}
              </p>
              {/* </div> */}
              {/* <div>
                  <p className="car-price my-1 font text-capitalize">
                    {carPrice}/Day
                  </p>
                </div> */}
            </div>
            {/* </div> */}
          </div>
        </div>
        <ReactTooltip id="remove-fav" place="bottom" content="Remove" />
      </div>
    </div>
  );
};

export default React.memo(MyVehicleCard);
